import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-loading-indicator',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <span class="spinner" aria-hidden="true"></span>
    <span role="status" aria-live="polite" aria-atomic="true">{{ message }}</span>
  `,
  styles: [`
    :host { display: flex; align-items: center; justify-content: center; gap: .75rem; padding: 1rem; color: #334155; font-size: .875rem; font-weight: 600; }
    .spinner { flex: 0 0 auto; width: 1.25rem; height: 1.25rem; border: 2px solid #cbd5e1; border-top-color: #0369a1; border-radius: 50%; animation: loading-spin .8s linear infinite; }
    @keyframes loading-spin { to { transform: rotate(360deg); } }
    @media (prefers-reduced-motion: reduce) { .spinner { animation: none; } }
  `]
})
export class LoadingIndicatorComponent {
  @Input() message = 'Loading…';
}
